// ──────────────────────────────────────────────
// src/features/system/services/api/servicesApi.ts
// ──────────────────────────────────────────────
import { bff } from '@/lib/http/bff';

export interface Script {
  id_script: number;
  script_name: string;
  id_service: number;
  table_name?: string | null;
}

export interface Service {
  id_service: number;
  service_name: string;
  service_host?: string | null;
  service_port?: number | null;
  service_table?: string | null;
  scripts?: Script[]; // BFF augments with registry
}

export const fetchServicesApi = (): Promise<Service[]> =>
  bff.get<Service[]>('/services');

export interface CreateServiceInput {
  service_host: string; // required by rust add_service; service_name derived server-side
}

export const createServiceApi = (body: CreateServiceInput): Promise<Service> =>
  bff.post<Service>('/services', body);

export interface CreateScriptInput {
  id_service: number;
  script_name: string;
  table_name: string;
}

export const createScriptApi = (body: CreateScriptInput): Promise<Script> =>
  bff.post<Script>('/services/scripts', body);